import { Box, Card, Text } from '@csscompany/csds-components';
import { FacilityDetails } from '@csscompany/op-facility-finder';
import { rosetta } from '@csscompany/op-facility-finder';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import { useIsDesktop, useIsMobile } from '../../../utils/breakpoints';
import { Button } from '../../ui';

interface LeadFormProps {
  facility?: FacilityDetails;
  siteName: string;
}

const StyledCard = styled(Card)`
  width: 100%;
  background: var(--grey-1);
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  padding: ${(props) => props.theme.space.$2};
  @media (min-width: 640px) {
    border-radius: 0;
    position: absolute;
  }
`;

const FooterContainer = styled(Box)`
  margin-bottom: 16px;
  @media (max-width: 640px) {
    padding-block-start: ${(props) => props.theme.space.$5};
    background-color: var(--grey-1);
    z-index: 10;
    position: fixed;
    width: 100%;
    inset-inline-start: 0;
    inset-block-end: 60px;
    border-top: 1px solid ${(props) => props.theme.colors.$staticDividerWeak};
  }
`;

export const LeadForm = ({ facility, siteName }: LeadFormProps) => {
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  const modalBody = useMemo(() => {
    return (
      <Box display="sticky">
        {facility ? (
          <Box display="flex" flexDirection="column" gap="$6" width="100%">
            {!isMobile && (
              <Box width="100%" display="flex" flexDirection="column" gap="$2">
                <Text variant="$headingSmall" color="$staticTextStrong">
                  {rosetta.lead_form_title.getText()}
                </Text>
                <Text variant="$paragraphMedium" color="$staticTextStandard">
                  {rosetta.lead_form_body.getText({ siteName })}
                </Text>
              </Box>
            )}
          </Box>
        ) : (
          <></>
        )}
      </Box>
    );
  }, [isDesktop, isMobile]);

  const CtaFooter = () => (
    <FooterContainer className="mx-[16px]">
      <Button globalTypeform utm_content="ff-details-cta" fullWidth>
        <Text variant="$labelSmallBold">
          {rosetta.facility_card_book_tour_button.getText()}
        </Text>
      </Button>
    </FooterContainer>
  );

  return (
    <>
      <StyledCard body={modalBody} footer={!isMobile && <CtaFooter />} />
      {isMobile && <CtaFooter />}
    </>
  );
};
